import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const materialAssemblyUiNodeSpec: UiNodeSpec<'materialAssembly'> = {
    cfg: () => ({
        kind: 'materialAssembly',
        id: getUID(),
        controlValues: {
            materialsToAssemble: [],
        },
    }),
    controls: () => ({}),
    requiredSockets: [ 'trigger', 'parentMaterial', 'componentMaterialId' ],
    inputs: () => {
        return {
            // ...cfg.controlValues.materialsToAssemble.reduce((acc, _, index) => { // TODO: reimplement
            //     acc[`material_id${index}`] = new UiFlowNodeInput({
            //         control: new UiFlowNodeControl({
            //             nodeCfg: cfg,
            //             value: cfg.controlValues.materialsToAssemble[index],
            //             cfg: {
            //                 kind: 'text',
            //             },
            //         }),
            //         socket: new UiFlowNodeSocket('string'),
            //         label: `Material ID ${index + 1}`,
            //         index,
            //     });
            //     return acc;
            // }, {} as ReturnType<UiNodeSpec<'materialAssembly'>['inputs']>),
            trigger: { socket: 'event', label: 'Trigger' },
            parentMaterial: { socket: 'string', label: 'Assembly Material ID' },
            componentMaterialId: { socket: 'string', label: 'Component Material ID' },
        };
    },
    kindLabel: 'Material Assembly',
    nodeCategory: 'argonautApi',
    outputs: () => ({
        good: { socket: 'event', label: 'Good' },
        bad: { socket: 'event', label: 'Bad' },
    }),
    validator: () => true,
};
